import { useQuery } from '@tanstack/react-query';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllLocations } from '../../network/location';
import { location } from '../../types/calendar';
import { salonSVG } from '../../assets/SVGs/SVGs';
import { Select } from 'antd';
import {
  setActiveLocation,
  setLocationId,
} from '../../services/store/slices/calender';

interface SalonLocationsSelectProps {
  activeLocations?: number[];
}

const SalonLocationsSelect: FC<SalonLocationsSelectProps> = ({
  activeLocations,
}) => {
  const { locationId, activeLocation } = useSelector(
    (state: {
      calendar: {
        locationId: number | null;
        activeLocation: location | null;
      };
    }) => {
      return {
        locationId: state?.calendar?.locationId,
        activeLocation: state?.calendar?.activeLocation,
      };
    }
  );
  const dispatch = useDispatch();

  const { data: salonLocations, isLoading } = useQuery(
    ['locations'],
    getAllLocations,
    {
      onSuccess: () => {
        if (!locationId || !activeLocation) {
          dispatch(setLocationId(salonLocations?.data?.[0]?.id));
          dispatch(setActiveLocation(salonLocations?.data?.[0]));
        }
      },
      cacheTime: 1000 * 60 * 60 * 24 * 7,
      staleTime: 1000 * 60 * 60 * 24 * 7,
    }
  );
  useEffect(() => {
    if (!locationId && salonLocations?.data?.length > 0) {
      dispatch(setLocationId(salonLocations?.data?.[0]?.id));
      dispatch(setActiveLocation(salonLocations?.data?.[0]));
    }
    if (locationId) {
      const existLocation = salonLocations?.data?.find(
        (location: location) => location?.id === locationId
      );
      if (!existLocation) {
        dispatch(setLocationId(salonLocations?.data?.[0]?.id));
        dispatch(setActiveLocation(salonLocations?.data?.[0]));
      } else {
        dispatch(setLocationId(locationId));
        dispatch(setActiveLocation(existLocation));
      }
    }
  }, [salonLocations]);
  const options = Array.isArray(salonLocations?.data)
    ? salonLocations?.data?.map((option: location) => {
        return {
          label: (
            <div className="flex items-center gap-2 w-fit">
              <span className=" block ">{salonSVG}</span>
              <span className="block ">{option?.name}</span>
            </div>
          ),
          key: option?.id,
          value: option?.id,
          icon: salonSVG,
          disabled: activeLocations
            ? !!!activeLocations?.includes(option?.id)
            : false,
        };
      })
    : [];
  const changeSelectedSalonLocation = (location: number | null) => {
    if (!location) return;
    dispatch(setLocationId(location));
    dispatch(
      setActiveLocation(
        salonLocations?.data?.find(
          (locationItem: location) => locationItem?.id === Number(location)
        )
      )
    );
  };

  return (
    // <Spin spinning={isLoading}>
    <Select
      defaultActiveFirstOption={true}
      loading={isLoading}
      onChange={(value) => {
        changeSelectedSalonLocation(value);
      }}
      popupMatchSelectWidth={false}
      className=" h-12 w-fit min-w-[100px]"
      options={options}
      value={
        options.find(
          (option: { value: number | string | null }) =>
            option.value === locationId
        ) || options[0]
      }
    />
    // </Spin>
  );
};

export default SalonLocationsSelect;
